import { WithLoader } from '@/components/WithLoader';
import { SpendSummaryTable } from '@/dashboards/SpendSummary/components/SpendSummaryTable';
import { SpendSummaryTotals } from '@/dashboards/SpendSummary/components/SpendSummaryTotals';
import { useSpendSummaryQuery } from '@/dashboards/SpendSummary/hooks';

/**
 * Layout for the Spend Summary tile: the headline KPI cards over the
 * breakdown table, both behind one loader. Each child owns its own data.
 */
export const SpendSummaryTableSection = () => {
    const { queryResult } = useSpendSummaryQuery();
    const { isLoading, isFetching } = queryResult;

    return (
        <div className="glass-tile flex flex-col p-8 max-lg:px-5 max-lg:max-w-full">
            <WithLoader isLoading={isLoading} isFetching={isFetching}>
                <SpendSummaryTotals />
                <SpendSummaryTable />
            </WithLoader>
        </div>
    );
};
